// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_dsg","cls2":"SimplePaperPodcast-cls2_l5U SimplePaperPodcast-cls1_dsg"};